import { PageHeader, Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useLoggedInEmployeeProfile } from "Shared/hooks/user.hooks"

const { TabPane } = Tabs

const UserIntegrations = React.lazy(() => import("./userIntegrations"))
const CompanyIntegrations = React.lazy(() => import("./companyIntegrations"))

const IntegrationsContainer = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const loggedInUser = useLoggedInEmployeeProfile()

    const tabs = [
        loggedInUser.activeCompanyProfile.isAdmin
            ? {
                  title: t("label:company_integrations"),
                  component: <CompanyIntegrations />,
              }
            : {},
        {
            title: t("label:user_integrations"),
            component: <UserIntegrations />,
        },
    ]

    return (
        <div className="w-full">
            <div className="md:hidden">
                <PageHeader
                    ghost={false}
                    onBack={() => history.push("/settings")}
                    title={<h2 className="mb-0 text-xs sm:text-sm md:text-lg">{t("label:integrations")}</h2>}
                ></PageHeader>
            </div>
            <div className="justify-between items-center mb-10 hidden md:flex">
                <h2 className="mb-0">{t("label:integrations")}</h2>
            </div>

            <Tabs defaultActiveKey="0">
                {tabs.map((tab, index) => (
                    <TabPane tab={tab.title} key={index} className="pb-10">
                        {tab.component}
                    </TabPane>
                ))}
            </Tabs>
        </div>
    )
}

export default React.memo(IntegrationsContainer)
